import { pageTitleMiddleware, authMiddleware } from '@/router/middleware';
import anonymousRoutes from '@/router/routes/anonymous';
import authenticatedRoutes from '@/router/routes/authenticated';

// Export the routes array
export const routes = [
  ...anonymousRoutes,
  ...authenticatedRoutes,
];

export const scrollBehavior = (to, from, savedPosition) => {
  if (to.hash) {
    return {
      el: to.hash,
      behavior: 'smooth',
    };
  }

  // Scroll to top if on the same route
  if (to.name === from.name) {
    to.meta?.scrollPos && (to.meta.scrollPos.top = 0);
    return { left: 0, top: 0 };
  }

  return savedPosition || to.meta?.scrollPos || { left: 0, top: 0 };
};

// export const router = createRouter({
//   history: createWebHistory(import.meta.env.BASE_URL),
//   routes: [
//     ...anonymousRoutes,
//     ...authenticatedRoutes,
//   ],
//   scrollBehavior,
// });

// router.afterEach(pageTitleMiddleware);
// router.beforeEach(authMiddleware);

export { pageTitleMiddleware, authMiddleware };
